import { TranslationProvider } from "@/i18n";
import { lightTheme } from "@/themes";
import { FluentProvider } from "@fluentui/react-components";
import React from "react";
import { AppAccountProvider } from "./AppAccountProvider";
import { AppAuthProvider } from "./AppAuthProvider";
import { AppCurrentVersionProvider } from "./AppCurrentVersionProvider";
import { AppFrontendAddonProvider } from "./AppFrontendAddonProvider";
import { AppHead } from "./AppHead";
import { AppNotificationProvider } from "./AppNotificationProvider";
import { AppOrgsAndInvitedOrgsProvider } from "./AppOrgsAndInvitedOrgsProvider";

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <TranslationProvider>
      <FluentProvider theme={lightTheme}>
        <AppAuthProvider>
          <AppAccountProvider>
            <AppOrgsAndInvitedOrgsProvider>
              <AppCurrentVersionProvider>
                <AppNotificationProvider>
                  <AppFrontendAddonProvider>
                    <AppHead />
                    {children}
                  </AppFrontendAddonProvider>
                </AppNotificationProvider>
              </AppCurrentVersionProvider>
            </AppOrgsAndInvitedOrgsProvider>
          </AppAccountProvider>
        </AppAuthProvider>
      </FluentProvider>
    </TranslationProvider>
  );
};
